import {useEffect, useState} from 'react'
import {sanityClient} from './client'
import {pageBySlugQuery} from './queries'

export function usePage(slug) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    sanityClient
      .fetch(pageBySlugQuery, {slug})
      .then((res) => {
        if (!cancelled) {
          setData(res || null)
          setLoading(false)
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err)
          setLoading(false)
        }
      })
    return () => {
      cancelled = true
    }
  }, [slug])

  return {data, loading, error}
}

